import Footer from "./Footer";
import Search from "./Search";

export default function About() {
  return (
    <>
      <section className="aboutUs">
        <Search />
        <h3 className="headingTitle">About Us</h3>
        <div className="abtSec">
          <div className="bgb"></div>
          <div className="abtCnt">
            <p className="wlc">
              {" "}
              Welcome to BuyVal, where we make you a seller and find you a buyer
            </p>
            <p className="jrn">
              {" "}
              Our journey began with a simple idea: to create a seamless space
              for you to discover and embrace exceptional products. Explore the
              world of online shopping with us.
            </p>
          </div>
        </div>
        <div className="wrapper">
          <div className="resp">
            <div className="heading">
              <h3 className="h3">Our Vision</h3>
              <div className="line"></div>
            </div>
            <p className="">
              Empowering business and individuals through seamless connection.
              BuyVal envisions a world where every seller finds their ideal
              buyer, fostering a thriving community of commerce and
              collaboration
            </p>
          </div>
          <div className="wrapp">
            <div className="heading">
              <h3 className="h3">Our Vision</h3>
              {/* <div className="line"></div> */}
            </div>
            <div className="par">
              <img src="/L-page_assets/mckup.png" alt="" className="mckup" />
              <div className="rightImg">
                <div className="bgb"></div>
                <div className="cont">
                  <div>
                    <span></span>
                    <img
                      src="/L-page_assets/globe.png"
                      className="globe"
                      alt=""
                    />
                  </div>
                  <p className="">
                    Empowering business and individuals through seamless
                    connection. BuyVal envisions a world where every seller
                    finds their ideal buyer, fostering a thriving community of
                    commerce and collaboration
                  </p>
                  <img src="/L-page_assets/spy_glass.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper">
          <div className="resp">
            <div className="heading">
              <h3 className="h3 ttl">Our Mission</h3>
              <div className="line dsh"></div>
            </div>
            <p>
              At our core, we are dedicated to simplifying the Journey of
              selling and buying .Our mission is to provide a user-centric
              e-commerce experience, leveraging innovative technologies to match
              sellers with the right buyers effortlessly. We strive to create a
              platform where transaction are not just transaction but the
              beginning of lasting partnership and transforming the way people
              do business online
            </p>
          </div>
          <div className="wrapp">
            <div className="heading">
              <h3 className="h3 ttl">Our Mission</h3>
              {/* <div className="line dash"></div> */}
            </div>
            <div className="par">
              <div className="rightImg">
                <div className="bgb"></div>
                <div className="cont">
                  <div>
                    <span></span>
                    <img
                      src="/L-page_assets/archer.png"
                      className="globe"
                      alt=""
                    />
                  </div>
                  <p>
                    At our core, we are dedicated to simplifying the Journey of
                    selling and buying .Our mission is to provide a user-centric
                    e-commerce experience, leveraging innovative technologies to
                    match sellers with the right buyers effortlessly. We strive
                    to create a platform where transaction are not just
                    transaction but the beginning of lasting partnership and
                    transforming the way people do business online
                  </p>
                  <img src="/L-page_assets/spy_glass.svg" alt="" />
                </div>
              </div>
              <img src="/L-page_assets/mckup.png" alt="" className="mckup" />
            </div>
          </div>
        </div>

        <div className="sec3">
          <div className="wrap">
            <div className="part1">
              <h3>How to sell on Buyval?</h3>
              <ol>
                <li>
                  <p className="head">Register</p>
                  <p className="cont">
                    Click on the Register button and fill in the required
                    information. Make sure you’re entering a correct phone
                    number, so your clients could reach you!{" "}
                  </p>
                </li>
                <li>
                  <p className="">Make photos of your items</p>
                  <p className="cont">
                    Feel free to make a lot of photos using your smartphone.
                    Make sure they show your item in the best light.{" "}
                  </p>
                </li>
                <li>
                  <p className="head">Choose a proper category</p>
                  <p className="cont">
                    upload your photos and write a clear title and full
                    description of your item. Enter a fair price, select
                    attributes and send your advert to review!{" "}
                  </p>
                </li>
                <li>
                  <p className="">
                    {" "}
                    Answer the messages and calls from your clients!
                  </p>
                  <p className="cont">
                    If everything is ok with your advert, it’ll be on Buyval
                    market place in a couple of hours after sending to
                    moderation.{" "}
                  </p>
                </li>
              </ol>
            </div>
            <div className="part2">
              <img src="/L-page_assets/how.png" alt="" />
              <button className="btn">Become a seller</button>
            </div>
          </div>
          <div className="wrap">
            <div className="part2">
              <img src="/L-page_assets/pos.png" alt="" />
              <button className="btn shp">Go shopping</button>
            </div>
            <div className="part1">
              <h3>How to buy on Buyval?</h3>
              <ol>
                <li>
                  <p className="head">Search for the item.</p>
                  <p className="cont">
                    Find what you need using search panel and filters. We have
                    over a thousand adverts, choose exactly what you are looking
                    for.{" "}
                  </p>
                </li>
                <li>
                  <p className="">Contact a seller</p>
                  <p className="cont">
                    You may use chat on Buyval or call them via phone. Discuss
                    all the details, negotiate about the price.{" "}
                  </p>
                </li>
                <li>
                  <p className="head">Take your item</p>
                  <p className="cont">
                    We check our sellers carefully, but it’s always better to
                    check twice, right? Meet a seller in public place and
                    collect your item.{" "}
                  </p>
                </li>
                <li>
                  <p className=""> Leave your feedback about the seller</p>
                  <p className="cont">
                    Feel free to tell us about your purchase. Your feedback will
                    be published online on the seller’s page and will be very
                    helpful for other buyers. Let’s build a safe and
                    professional business community together!{" "}
                  </p>
                </li>
              </ol>
            </div>
          </div>
          <div className="wrap">
            <div className="part1">
              <h3>Safety</h3>
              <ol>
                <li>
                  <p className="head">General</p>
                  <p className="cont">
                    Click on the Register button and fill in the required
                    information. Make sure you’re entering a correct phone
                    number, so your clients could reach you!{" "}
                  </p>
                </li>
                <li>
                  <p className="">Personal safet tips</p>
                  <p className="cont">
                    Try to meet at a safe, public location Check the item
                    thoroughly
                  </p>
                </li>
                <li>
                  <p className="head">Secure payments</p>
                  <p className="cont">
                  BuyVal provides Premium Services for those who want to sell and earn more. We guarantee secure and reliable payments on BuyVal.{" "}
                  </p>
                </li>
              </ol>
            </div>
            <div className="part2">
              <img src="/L-page_assets/vec.png" alt="" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
